import { call, delay, put, select, takeEvery, takeLatest, throttle } from 'redux-saga/effects';
import { SET_TOKEN } from '../auth/actions';
import { ADD_CONTENT, ADD_SAVED_BOX, APPLY_FILESIZE, COPY_CONTENT, DELETE_SAVED_BOX, DIALOG_HIDE, DIALOG_SHOW, EDIT_CONTAINER, EDIT_CONTENT, FOOTER_UPDATE, GET_CONTAINER, GET_CONTENTS, GET_EMAIL, GET_FILESIZE, GET_HISTORY, GET_LISTINFO, GET_LISTVARS, GET_SYSTEMFIELDS, HISTORY_APPLY, HISTORY_SAVE, LOAD_SAVED_BOXES, MOVE_CONTENT, REMOVE_CONTENT, RENAME_SAVED_BOX, REQUEST_SAVE, SAVE_BOX, SAVE_CONTENTS, SAVE_CONTENTS_LOCAL, SWITCH_CONTENT, SWITCH_TEST_GROUP, SYNC_TEST_GROUP_CONTENTS, addSavedBoxAsync, deleteSavedBoxAsync, getContainerAsync, getContentsAsync, getEmailAsync, getFilesizeAsync, getHistoryAsync, getListInfoAsync, getListVarsAsync, getSystemFieldsAsync, loadSavedBoxesAsync, renameSavedBoxAsync, requestSave, saveBoxAsync, saveContentsAsync, saveContentsLocal, selectContent, setDefaultShop, setShops, setTestGroup, toggleContentsTargetLoading, toggleIsContentsLoading, toggleIsSaving } from './actions';
import { checkoutSnapshot, deleteSavedBox, generateMap, getLastModifiedGroup, getMetaInfo, getYoutubeThumbnail, loadSavedBoxDetail, loadSavedBoxes, postContents, postContentsSnapshot, putContainer, putContentsLocal, removeUploadedImage, requestContainer, requestContents, requestContentsLocal, requestContentsSnapshot, requestEmail, requestFilesize, requestGenerateHtml, requestListInfo, requestListVars, requestOldContents, requestSaveHtml, requestShops, requestSystemFields, saveSavedBox, syncTestGroupContents, updateMetaInfo, updateSavedBox } from './service';
import { Container, ContentsData, Email, HistoryItem, LastModifiedGroup, ListInfo, ListVars, MergeFields, RequestHtml, editorState } from './types';

import { components, shopTypeSet } from '../../config/components';

import dayjs from 'dayjs';
import produce from 'immer';

import Alert from '../../lib/Alert';
import { findFirstImagePath, maxBy } from '../../util/array';
import { formatBytes } from '../../util/file';
import { legacyContainerControl, legacyContentControl } from '../../util/legacyContentControl';
import { stringCss } from '../../util/parseStyle';

import { ActionType } from 'typesafe-actions';
import { RootState } from '..';
import { COMMON_STYLE_EXCLUDE_COMP, CONTENTS_SAVE_DURATION, HISTORY_SAVE_DURATION, LOCAL_STORAGE_SAVE_LIMIT, SEC, TEXT_TEMPLATE } from '../../constants';
import { checkStyleEdited } from '../../util/dom';
import { convertToOriginEmail } from '../../util/senderEmail';
import { urlToStartTime } from '../../util/string';

function* setTokenSaga() {
	const { editor: { emailId }} = yield select();	
	yield put(getEmailAsync.request(emailId));
}

function* getSystemFieldsSaga() {
	const msg = yield select(state => state.editor.service.msg);
	
	try {
		const systemFields: MergeFields = yield call(requestSystemFields);
		yield put(getSystemFieldsAsync.success(systemFields));
	} catch (e) {
		window.parent.postMessage({ msg: 'backToStep', step: '1' }, '*');
		Alert.error(msg.CHECK_SELECT_LISTS);
		console.error(e);
	}
}

function* getListVarsSaga() {
	const state = yield select();	
	const msg = yield select(state => state.editor.service.msg);

	if (state.editor.email.listId === undefined || state.editor.email.listId === -1 || state.editor.email.isListDeleted) {
		window.parent.postMessage({ msg: 'backToStep', step: '1' }, '*');
		Alert.error(msg.CHECK_SELECT_LISTS);
		return;
	}
	try {
		const listVars: ListVars = yield call(requestListVars, state.editor.email.listId);
		yield put(getListVarsAsync.success(listVars));
	} catch (e) {
		window.parent.postMessage({ msg: 'backToStep', step: '1' }, '*');
		Alert.error(msg.CHECK_SELECT_LISTS);
		console.error(e);
	}
}

function* getListInfoSaga() {
	const state = yield select();
	const isCafe24Workspace = state.auth.account.from === 'CAFE24';
	const msg = yield select(state => state.editor.service.msg);
	
	if (state.editor.email.listId === undefined || state.editor.email.listId === -1 || state.editor.email.isListDeleted) {
		window.parent.postMessage({ msg: 'backToStep', step: '1' }, '*');
		Alert.error(msg.CHECK_SELECT_LISTS);
		return;
	}
	try {
		const listInfo: ListInfo = yield call(requestListInfo, state.editor.email.listId);
		if (isCafe24Workspace) {
			try {
				const shops = yield call(requestShops);
				yield put(setShops(shops));
				if (listInfo.listType === 'CAFE24' && listInfo.shopNo !== -1) {
					const linkedShop = shops.find((shop) => shop.list_id === state.editor.email.listId);
					yield put(setDefaultShop(linkedShop));
				} else {
					const defaultShop = shops.find((shop) => shop.is_default);
					yield put(setDefaultShop(defaultShop));
				}
			} catch (e) {
				console.error(e);
			}
		}
		yield put(getListInfoAsync.success(listInfo));
	} catch (e) {
		window.parent.postMessage({ msg: 'backToStep', step: '1' }, '*');
		Alert.error(msg.CHECK_SELECT_LISTS);
		console.error(e);
	}
}

function* legacyFilter(contents: any, isOld?: boolean, templateId?: number) {
	if (contents === null || contents.length === 0) {
		return [];
	}
	try {

		const nextDataFilterd = contents.filter((item:any) => {
			return item !== undefined && item !== null && item['content'] !== null && item['content'].length !== 0 && item['content'] !== ' ' && item['content'] !== '';
		});

		const nextData:any = produce(nextDataFilterd, (draft:any) => {
			draft.map((item:any) => {
				item['content'] = legacyContentControl(item['content'], isOld, templateId);
			});
		});
	
		return nextData;

	} catch (error) {
		console.error(error);
		return [];
	}
}

function* getContentsSaga(action: any) {
	console.log('%cgetContentsSaga', 'color: black; background: skyblue');

	yield put(toggleIsContentsLoading(true));

	const state = yield select();
	const isContentsAbtest = state.editor.email.type === 2 && state.editor.email.subType === 4;
	const templateId = state.editor.email.templateId;
	let testGroup = undefined;
	if (isContentsAbtest) {
		testGroup = state.editor.testGroup;
	}
	
	try {
		let saveKey = `stb_email_${state.editor.email.id}_contents`;
		if (testGroup) saveKey = saveKey + `_${testGroup}`;
		
		let { lastModifiedTime: localLastModifiedTime, data: localData }:ContentsData = yield call(requestContentsLocal, saveKey);

		let { lastModifiedTime: serverLastModifiedTime, data: serverData }: ContentsData = yield call(requestContents, action.payload, testGroup);	
		const serverDataString = JSON.stringify(serverData);
		const isCafe24Onboarding = serverDataString.includes('{{#shop_primary_domain#}}') && serverDataString.includes('{{#footer#}}');
		if (isCafe24Onboarding) {
			serverData = JSON.parse(serverDataString.replace('{{#shop_primary_domain#}}', state.editor.defaultShop.primary_domain).replace('{{#store_shop_name#}}', state.editor.defaultShop.store_shop_name));
		}
		
		const localIsEmpty = localData === undefined || localData === null || localData?.length === 0;
		const serverIsEmpty = serverData === undefined || serverData === null;		

		// 로컬, 서버에 존재하지 않는다면 old contents 요청
		// if (true) {
		if (localIsEmpty && serverIsEmpty) {
			const oldContents = yield call(requestOldContents, action.payload);
			const contentsData = yield call(legacyFilter, oldContents, true, templateId);
			yield delay(100);
			yield put(getContentsAsync.success(contentsData));
			yield delay(100);
			yield put(toggleIsContentsLoading(false));
			return;
		}

		if (serverLastModifiedTime === -1 && localLastModifiedTime === -1) {
			yield delay(100);
			yield put(getContentsAsync.success([]));
			yield delay(100);
			yield put(toggleIsContentsLoading(false));
			return;
		}

		// 서버 데이터 없음 
		if (serverIsEmpty) {
			const contentsData = yield call(legacyFilter, localData, false, templateId);      
			yield delay(100);
			yield put(getContentsAsync.success(contentsData));
			yield delay(100);
			yield put(toggleIsContentsLoading(false));
			return;
		}
		// 로컬 데이터 없음 
		if (localIsEmpty) {			
			const contentsData = yield call(legacyFilter, serverData, false, templateId);
			yield delay(100);
			yield put(getContentsAsync.success(contentsData));
			yield delay(100);
			if (isCafe24Onboarding) {
				const footerContentId = serverData?.find((item) => item.content.category === 'footer')?.id;
				yield call(footerUpdateSaga, { payload: footerContentId });
			}
			yield put(toggleIsContentsLoading(false));
			return;
		}
		// 로컬이 최신
		if (localLastModifiedTime >= serverLastModifiedTime) {
			const contentsData = yield call(legacyFilter, localData, false, templateId);      
			yield delay(100);
			yield put(getContentsAsync.success(contentsData));
			yield delay(100);
			yield put(toggleIsContentsLoading(false));
			yield put(saveContentsAsync.request());
			return;
		}
		// 서버가 최신
		if (localLastModifiedTime < serverLastModifiedTime) {
			const contentsData = yield call(legacyFilter, serverData, false, templateId);	
			yield delay(100);
			yield put(getContentsAsync.success(contentsData));
			yield delay(100);
			yield put(toggleIsContentsLoading(false));
			return;
		}

	} catch (e) {
		yield put(getContentsAsync.failure(e));
		console.error(e);
	}
}

function* removeUploaded (imagePath: string, refreshTotalSize?: boolean) {
	const state = yield select();	
	const isContentsAbtest = state.editor.email.type === 2 && state.editor.email.subType === 4;
	let testGroup = undefined;
	if (isContentsAbtest) {
		testGroup = state.editor.testGroup;
	}

	const {totalSize} =	yield call(removeUploadedImage, state.editor.emailId, imagePath.substring(imagePath.lastIndexOf('/') + 1), testGroup);
	if (refreshTotalSize) {
		yield call(applyFilesizeSaga, {payload: totalSize})
	}
}

function* removeContentSaga(action:any) {
	const state = yield select();
	const msg = yield select(state => state.editor.service.msg);	
	const { payload } = action;
	
	if (state.editor.contents.length === 1) {
		Alert.error(msg.DELETE_LAST_BOX_ERROR);
		return;
	}

	const targetContent = state.editor.contents?.find((item) => item.id === payload);

	let metaInfo = {};
	let metaImageDeleted = false;

	const firstColImagePath = targetContent?.content?.content[0]?.imagePath;
	const secondColImagePath = targetContent?.content?.content[1]?.imagePath;

	if ( (firstColImagePath && !firstColImagePath.includes('dummy')) || (secondColImagePath && !secondColImagePath.includes('dummy'))) {
		const result = yield call(getMetaInfo, state.editor.email.id);
		if (result) {
			metaInfo = result;
		}
	}

	const isFirstImageDummy = targetContent?.content?.content[0]?.imagePath?.includes('dummy');
	if (targetContent?.content?.content[0]?.imagePath && !isFirstImageDummy) {
		yield call(removeUploaded, targetContent.content.content[0].imagePath, true);
		if (metaInfo.imageUrl === targetContent.content.content[0].imagePath) {
			metaImageDeleted = true;
		}
	}
	const isSecondImageDummy = targetContent?.content?.content[1]?.imagePath?.includes('dummy');
	if (targetContent?.content?.content[1]?.imagePath && !isSecondImageDummy) {
		yield call(removeUploaded, targetContent.content.content[1].imagePath, true);
		if (metaInfo.imageUrl === targetContent.content.content[1].imagePath) {
			metaImageDeleted = true;
		}
	}

	// 상자 내 이미지 삭제 로직 실행 후에 redux에 저장된 컨텐츠 값을 새롭게 불러옴
	const updatedEditor = yield select(state => state.editor);
	updatedEditor.contents = produce(updatedEditor.contents, (draft: any[]) => {
		draft.forEach(({ id }, i) => {
			if (id !== payload) return;
			draft.splice(i, 1);
		})
		draft.map((item:any, index:number) => {
			item.seq = index;
		})
	});
	
	if (metaImageDeleted) {
		const firstImageUrl = findFirstImagePath(updatedEditor.contents);
		const data = {...metaInfo, imageUrl: firstImageUrl}
		yield call(updateMetaInfo, state.editor.email.id, data);
	}

	yield put(getContentsAsync.success(updatedEditor.contents));
	yield put(saveContentsLocal());
	yield put(selectContent(-1));

	yield delay(100);

	yield call(saveEmailAndWebContentsSaga);
}

function* copyContentSaga(action:any) {
	const { seq, originalIndex } = action.payload;	

	yield put(selectContent(-1));
	yield delay(100);
	
	const state = yield select();	
	
	let content = JSON.parse(JSON.stringify(state.editor.contents.filter((item:any, index:number) => index === originalIndex)[0].content));

	content.content.map((item: any, index: number) => {
		if (item.imagePath && !item.imagePath.includes('dummy')) {
			item.imagePath = item.imagePath + '?' + Math.random().toString(36).slice(2, 10);
		}
	});

	let newContent = {
		id: state.editor.contents.length === 0 ? 0 : maxBy(state.editor.contents, 'id') + 1,
		seq: seq,
		content: content
	}

	const nextContents: any = produce(state.editor.contents, (draft: any) => {
		draft.splice(seq, 0, newContent);
		draft.map((item: any, index: number) => {
			item.seq = index;
		})
	});

	yield put(getContentsAsync.success(nextContents));
	yield put(saveContentsLocal());
}

function* getEmailSaga(action: ReturnType<typeof getEmailAsync.request>) {
	console.log('%c📩getEmailSaga', 'color: black;background:yellowgreen');

	try {
		const email: Email = yield call(requestEmail, action.payload);

		yield put(getEmailAsync.success(email));
    
    const listId = yield select(state => state.editor.email.listId);
    const isListDeleted = yield select(state => state.editor.email.isListDeleted)
    const hasNoList = listId === -1 || listId === undefined || isListDeleted;
    if (!hasNoList) {
      yield call(getListInfoSaga);
      yield call(getListVarsSaga);
    }
		yield call(getSystemFieldsSaga);

		if (email.type === 2 && email.subType === 4) {
			const lastModifiedGroup: LastModifiedGroup = yield call(getLastModifiedGroup, action.payload);
			yield put(setTestGroup(lastModifiedGroup.abType));
		}
		
			yield put(getContentsAsync.request(email.id));
			yield put(getContainerAsync.request(email.id));
			
		yield put(getFilesizeAsync.request(email.id));
		yield put(getHistoryAsync.request({ emailId: email.id, offset: 0 }));
	} catch (e) {
		yield put(getEmailAsync.failure(e));
		console.error(e);
	}
}

function* getContainerSaga(action: ReturnType<typeof getContainerAsync.request>) {	
	console.log('%cgetContainerSaga', 'color: black; background: skyblue');
	const state = yield select();
	const isContentsAbtest = state.editor.email.type === 2 && state.editor.email.subType === 4;
	let testGroup: editorState['testGroup'];
	if (isContentsAbtest) {
		testGroup = yield select(state => state.editor.testGroup);
	}

	try {
		const state = yield select();
		const container: any = yield call(requestContainer, action.payload, testGroup);
		const templateId = state.editor.email.templateId;
		const filtedContainer: Container = legacyContainerControl(container, templateId);

		if (Object.keys(filtedContainer).length !== 0) {
			yield put(getContainerAsync.success({...state.editor.container, ...filtedContainer}));
		}
		
	} catch (e) {
		yield put(getContainerAsync.failure(e));
		console.error(e);
	}

	yield call(applyCommonStyleToContent, ['', 'link']);
}

function* editContainerSaga(action:any) {	
	const state = yield select();
	const isContentsAbtest = state.editor.email.type === 2 && state.editor.email.subType === 4;
	let testGroup = undefined;
	if (isContentsAbtest) {
		testGroup = yield select(state => state.editor.testGroup);
	}

	try {
		yield call(putContainer, state.editor.email.id, action.payload, testGroup);
	} catch (error) {
		console.error(error);
	}
}

function* getFilesizeSaga(action: any) {
	const state = yield select();
	const isContentsAbtest = state.editor.email.type === 2 && state.editor.email.subType === 4;
	let testGroup: editorState['testGroup'] = undefined;
	if (isContentsAbtest) {
		testGroup = yield select(state => state.editor.testGroup);
	}

	const { totalSize } = yield call(requestFilesize, action.payload, testGroup);

	yield call(applyFilesizeSaga, {payload: totalSize})
}

function* applyFilesizeSaga(action:any) {
	const state = yield select();
	const imageLimit = yield select(state => state.auth.plan.imageLimit);
	const totalSize = ((imageLimit * 1000 * 1000) - action.payload);
	
	let newServiceState = {
		...state.editor.service,
		...{totalSize: formatBytes(totalSize, 1)}
	}
	
	yield put(getFilesizeAsync.success(newServiceState));

	yield delay(100);

	yield call(saveEmailAndWebContentsSaga);
}

function applyContentData(target:string[], value:any, prevState:any) {	
	const nextState = produce(prevState, (draft:any) => {

		const targetItemIndex: any = draft.findIndex((item: any) => { return item.id === Number(target[0]) });

			try {
				if (targetItemIndex === -1) {
					return;
				}
		
				if (target.length === 2) {
					draft[targetItemIndex].content[target[1]] = value;
				}
				if (target.length === 3) {
					draft[targetItemIndex].content[target[1]][target[2]] = value;
				}
				if (target.length === 4) {
					draft[targetItemIndex].content[target[1]][target[2]][target[3]] = value;
				}
				if (target.length === 5) {
					draft[targetItemIndex].content[target[1]][target[2]][target[3]][target[4]] = value;
				}
				
			} catch (error) {
				console.error(error);
			}

		}		
	);

	return nextState;
}

function applyStyleData(target: string[], value: any, prevState:any, property?: string) {
	const nextState = produce(prevState, (draft: any) => {
		const targetItemIndex: any = draft.findIndex((item: any) => { return item.id === Number(target[0]) });
		
		try {
			if (property && target.length === 5) {
				target[4] = property;
			} 
			if (property && target.length === 6) {
				target[5] = property;
			} 
			if (target.length === 2) {
				draft[targetItemIndex].content[target[1]] = value;
			}
			if (target.length === 3) {
				draft[targetItemIndex].content[target[1]][target[2]] = value;
			}
			if (target.length === 4) {
				draft[targetItemIndex].content[target[1]][target[2]][target[3]] = value;
			}
			if (target.length === 5) {
				draft[targetItemIndex].content[target[1]][target[2]][target[3]][target[4]] = value;
			}
			if (target.length === 6) {
				draft[targetItemIndex].content[target[1]][target[2]][target[3]][target[4]][target[5]] = value;
			}
		} catch (error) {
			console.error(error);
		}

	});

	return nextState;	
}

function applyContainerData(target: string[], value: any, prevState: any) {
	const nextState = produce(prevState, (draft: any) => {
		draft[target[1]] = value;
	}
	);

	return nextState;	
}

function* applyCommonStyleData(target: string[], value: any, prevState: any) {
	const state = yield select();

	const nextState = produce(prevState, (draft: any) => {		
		const currentValue = draft[target[0]][target[1]][target[2]];
		let newValue:string = value;

		switch (target[2]) {
			case 'fontWeight':
				newValue = currentValue === 'bold' ? 'normal' : 'bold';
				draft[target[0]][target[1]][target[2]] = newValue;
				break;

			case 'fullWidth':
				newValue = (!currentValue || currentValue === 'auto') ? '100%' : 'auto';
				draft[target[0]][target[1]]['width'] = newValue;
				draft[target[0]][target[1]][target[2]] = newValue === '100%' ? 'wide': '';
				break;
			
			case 'buttonType':
				const buttonTypeValue = state.editor.option.buttonTypeOption[value];

				for (const key in buttonTypeValue) {
					if (Object.prototype.hasOwnProperty.call(buttonTypeValue, key)) {
						const value = buttonTypeValue[key];
						draft[target[0]][target[1]][key] = value;
					}
				}
				draft[target[0]][target[1]][target[2]] = value;
				break;
			
			case 'paddingLeft':
				draft[target[0]][target[1]][target[2]] = value;
				draft[target[0]][target[1]]['paddingRight'] = value;
				break;

			default:
				draft[target[0]][target[1]][target[2]] = value;
				break;
		}	

	});
	return nextState;
}

function* applyCommonStyleToContent(target: string[]) {
	const commonStyle = yield select(state => state.editor.container.commonStyle);	
	const contents = yield select(state => state.editor.contents);
	const targetField = target[1];
	const commonStyleBoxPaddings = yield call(commonStylePaddings);

	const nextData:any = produce(contents, (draft:any) => {
		draft.map((content:any) => {
			if (content.content.category === 'htmlcode') return;
			let targetStyle = content.content.type.includes('shop') ? content.content.style : [content.content.style];

			targetStyle.map((styleItem:any, index:number) => {				

				styleItem.map((style:any) => {

					// 실제 적용
					if (!COMMON_STYLE_EXCLUDE_COMP.includes(content.content.category)) {
						// 텍스트
						if(!content?.content?.edited?.includes('text')) {
							style['text'] = { ...style['text'], ...commonStyle.text }
						}
						
						// 링크 
						if (targetField === 'link') {
							content.content.content.map((item:any) => {
								if (item.text !== undefined) {
									let temp = document.createElement('div');
									temp.innerHTML = item.text;
									temp.querySelectorAll('a').forEach((aTag:any) => {
										try {
											
											let isEdited = false
											
											//a 태그 하위 span 스타일을 유저가 수정한적이 있는지 체크
											aTag.querySelectorAll('span').forEach((span:any) => {
												//유저의 스타일 변경 유무 체크
												const hasEditedSpan = checkStyleEdited(span)
												if(hasEditedSpan) {
													return isEdited = true;
												}

												span.setAttribute('style', stringCss(commonStyle.link, true));
												span.setAttribute('data-mce-style', stringCss(commonStyle.link, true));
											});
											
											if(checkStyleEdited(aTag)){
												return isEdited = true
											}
											
											let isMailtoAutolink = aTag.getAttribute('class')?.indexOf('stb-mailto') >-1


											//유저가 a태그 내부의 스타일을 수정한 적 있거나, mailto link인 경우 a태그에 링크 전체 스타일 적용하지 않음
											if(isEdited || isMailtoAutolink) return;
											
											aTag.setAttribute('style', stringCss(commonStyle.link, true));
											
										} catch (error) {
											console.error(error);
										}								
									});
									item.text = temp.innerHTML;
								}
							})					
						}
					}
	
					if (!content?.content?.edited?.includes('box')) {
						style['box'] = { ...style['box'], ...commonStyleBoxPaddings }
						style['outer'] = { ...style['outer'], ...commonStyle.outer }
					}
	
					if (!content?.content?.edited?.includes('partition')) {
						style['partition'] = { ...style['partition'], ...commonStyle.partition }
					}	
	
					if (!content?.content?.edited?.includes(`button0`) && !content?.content?.edited?.includes(`button1`)) {
						style['button'] = { ...style['button'], ...commonStyle.button }
					}
				})

			});

		});
	});	

	yield yield delay(10);
	
	yield put(getContentsAsync.success(nextData));

	return nextData;
}

function getCurrentData(target:any, obj:any) {	
	const targetItemIndex: any = obj.findIndex((item: any) => { return item.id === Number(target[0]) });
	target.shift();
	target.splice(0, 0, targetItemIndex);	
	return target.reduce(function (prev:any, curr:any) {
		return prev ? prev[curr] : null
	}, obj)	
}

function markEdited(target:string[], prevState:any, flag:string) {		
	const nextState = produce(prevState, (draft:any) => {
		const targetItemIndex: any = draft.findIndex((item: any) => { return item.id === Number(target[0]) });
		draft[targetItemIndex].content['edited'] = draft[targetItemIndex].content['edited'] || [];
		if (!draft[targetItemIndex].content['edited'].includes(flag)) {
			draft[targetItemIndex].content['edited'].push(flag);
		}		
	});

	return nextState;
}

function* editContentSaga(action: any) {
	console.log('%ceditContentSaga', 'color: black;background:orange');	
	console.log('editContentSaga', action);
		
	const state = yield select();
	const target = action.payload.target.split('/');
	const { data, videoId } = action.payload;
	const msg = yield select(state => state.editor.service.msg);
	const targetId = Number(target[0]);

	if (targetId === -1) {
		return;
	}

	if (target.includes('container')) {
		state.editor.container = yield call(applyContainerData, target, data, state.editor.container);

		switch (target[1]) {
			case 'borderWidth':
				if (state.editor.container.borderColor.length === 0) {
					state.editor.container = yield call(applyContainerData, ['container', 'borderColor'], '#000000', state.editor.container);
				}			
				
				break;
		
			default:
				break;
		}
		
		yield call(editContainerSaga, {payload: state.editor.container});
		return;
	}	

	if (target.includes('commonStyle')) {
		state.editor.container = yield call(applyCommonStyleData, target, data, state.editor.container);

		yield call(editContainerSaga, { payload: state.editor.container });
		yield call(applyCommonStyleToContent, target);

		yield delay(10);

		yield put(saveContentsLocal());

		return;
	}	

	let needsToSave = false;
	const content = state.editor.contents.find(({ id }) => id === targetId)?.content ?? {};
	const isForceSaveCategory = ((['map', 'video', 'htmlcode'].includes(content.category) || target.at(-1) === 'text') && action.payload.mode === 'force');

	const isFocusOut = state.editor.prevSelectedContentId === targetId;
	if (isFocusOut || isForceSaveCategory) {
		const value = target.reduce((content, key) => content[key] ?? content, content);
		const isTouchedContent = data !== value;
		needsToSave = isTouchedContent || isForceSaveCategory;
	}

	if (target.includes('content') || target[1] === 'column' || target[1] === 'type') {
		state.editor.contents = yield call(applyContentData, target, data, state.editor.contents);

		switch (true) {
			case target[1] === 'type':
				if (data.includes('shop')) {
					state.editor.contents = yield call(applyContentData, [target[0], 'column'], shopTypeSet[data], state.editor.contents);
				}
				break;
			case target[1] === 'content' && target[3] === 'imagePath':
				const targetItemIndex: any = state.editor.contents.findIndex((item: any) => { return item.id === Number(target[0]) });
				
				const oldImagePath = state.editor.contents[targetItemIndex].content.content[target[2]].imagePath;
        if (!oldImagePath.includes('dummy')) {
					yield call(removeUploaded, oldImagePath, false);
				}
				break;
		
			default:
				break;
		}
	}

	if (target.includes('style')) {
		state.editor.contents = yield call(applyStyleData, target, data, state.editor.contents);

		let lastTarget = target[4]; // ex) box
		if (target.length === 6) {
			lastTarget = target[5];
		}
		let middleTarget = target[3]; // ex) paddingLeft
		if (target.length === 6) {
			middleTarget = target[4];
		}

		switch (true) {
			case middleTarget === 'button' && lastTarget === 'fontSize':
				state.editor.contents = yield call(applyStyleData, target, state.editor.option.ctaPaddingBySize[action.payload.data], state.editor.contents, 'padding');
				break;

			case middleTarget === 'button' && lastTarget === 'buttonType':	
				// border-radius만 변경한다				
				state.editor.contents = yield call(applyStyleData, target, state.editor.option.buttonTypeOption[action.payload.data].borderRadius, state.editor.contents, 'borderRadius');
				break;

			case middleTarget === 'button' && lastTarget === 'fullWidth':
				state.editor.contents = yield call(applyStyleData, target, action.payload.data === 'wide' ? '100%' : 'auto', state.editor.contents, 'width');
				state.editor.contents = yield call(applyStyleData, target, 'center', state.editor.contents, 'textAlign');
				break;

			case middleTarget === 'button' && lastTarget === 'textAlign':
				state.editor.contents = yield call(applyStyleData, target, action.payload.data, state.editor.contents, 'textAlign');
				state.editor.contents = yield call(applyStyleData, target, '', state.editor.contents, 'fullWidth');
				state.editor.contents = yield call(applyStyleData, target, 'auto', state.editor.contents, 'width');
				break;

			case middleTarget === 'box' && lastTarget === 'paddingLeft':
				state.editor.contents = yield call(applyStyleData, target, action.payload.data, state.editor.contents, 'paddingRight');
				break;

			case middleTarget === 'box' && lastTarget === 'borderWidth':
				let t1 = [...target];
				t1.splice(1, 0, 'content');
				t1.pop();
				t1.push('borderColor');
				
				const currentBoxBorderColor = yield (getCurrentData(t1, state.editor.contents));
				
				if (currentBoxBorderColor.length === 0) {
					state.editor.contents = yield call(applyStyleData, target, '#000000', state.editor.contents, 'borderColor');
				}				
				break;

			case middleTarget === 'column' && lastTarget === 'paddingLeft':
				state.editor.contents = yield call(applyStyleData, target, action.payload.data, state.editor.contents, 'paddingRight');
				break;

			case middleTarget === 'image' && lastTarget === 'fullWidth':
				state.editor.contents = yield call(applyStyleData, target, data === 'justify' ? '100%' : 'auto', state.editor.contents, 'width');
				state.editor.contents = yield call(applyStyleData, target, data === 'justify' ? '' : 'center', state.editor.contents, 'textAlign');
				break;
			case middleTarget === 'image' && lastTarget === 'textAlign':
				let t2 = [...target];
				t2.splice(1, 0, 'content');
				t2.pop();
				t2.push('width');
				
				const currentWidth = yield (getCurrentData(t2, state.editor.contents));

				if (currentWidth === 'auto' || currentWidth === '100%') {
					state.editor.contents = yield call(applyStyleData, target, 'auto', state.editor.contents, 'width');
				}
				state.editor.contents = yield call(applyStyleData, target, '', state.editor.contents, 'fullWidth');
				break;
			case middleTarget === 'image' && lastTarget === 'width':
				state.editor.contents = yield call(applyStyleData, target, data === 'auto' ? '100%' : data, state.editor.contents, 'width');
				break;

			default:
				break;
		}

		// edited 마킹
		switch(middleTarget) {			
			case 'partition':
				state.editor.contents = markEdited(target, state.editor.contents, 'partition');
				break;				
			case 'button':
				state.editor.contents = markEdited(target, state.editor.contents, `button${target[2]}`);
				break;
			case 'box':
				state.editor.contents = markEdited(target, state.editor.contents, 'box');
				break;

			default:
				break;
		}
	}

	// 상자별 옵션	
	const targetItemIndex: any = state.editor.contents.findIndex((item: any) => { return item.id === Number(target[0]) });
	const targetItem = state.editor.contents[targetItemIndex];

	if (targetItemIndex === -1) {
		return;
	}	
	switch (targetItem?.content?.category) {
		case 'base': 
			if (target[3] === 'imagePath') {
				state.editor.contents = yield call(applyContentData, `${target[0]}/content/${target[2]}/imageAlt`.split('/'), '', state.editor.contents);
			}
			break;
		case 'video':
			if (target[3] === 'imageLink') {
				try {
					yield put(toggleContentsTargetLoading({ target: target.join('/'), isLoading: true }));
					
					const { imgUrl } = yield call(getYoutubeThumbnail, data, state.editor.emailId);
					const videoStartTime = urlToStartTime(data);
					const loadImage = async (imageUrl: string) => new Promise((res) => {
							const imageLoader = new Image();
							imageLoader.onload = () => res(true);
							imageLoader.onerror = () => res(false);
							imageLoader.src = imageUrl;
						});
					if (imgUrl) {
						yield call(loadImage, imgUrl);
					}
					yield put(toggleContentsTargetLoading({ target: target.join('/'), isLoading: false }));
					
					state.editor.contents = yield call(applyContentData, `${target[0]}/content/0/imagePath`.split('/'), imgUrl, state.editor.contents);
					state.editor.contents = yield call(applyContentData, `${target[0]}/content/0/imageAlt`.split('/'), '', state.editor.contents);
					state.editor.contents = yield call(applyContentData, `${target[0]}/content/0/videoId`.split('/'), videoId, state.editor.contents);
					const targetItemIdx: any = state.editor.contents.findIndex((item: any) => { return item.id === Number(target[0]) });
					const { videobox, embedvideo } = state.editor.contents[targetItemIdx].content.style[0];
					if (!(videobox && embedvideo)) {
						const { value: { style } } = components.find((item) => targetItem?.content?.category === item.value.category);
						const { videobox: videoboxStyle, embedvideo: embedvideoStyle } = style[0];
						state.editor.contents = yield call(applyStyleData, `${target[0]}/style/0/videobox`.split('/'), videoboxStyle, state.editor.contents);
						state.editor.contents = yield call(applyStyleData, `${target[0]}/style/0/embedvideo`.split('/'), embedvideoStyle, state.editor.contents);
					}
					if (!!videoStartTime) {
						state.editor.contents = yield call(applyContentData, `${target[0]}/content/0/videoStartTime`.split('/'), videoStartTime, state.editor.contents);
					}
				} catch (error) {
					console.error(error)
					Alert.error(msg.CHECK_VIDEO_URL);
						state.editor.contents = yield call(applyContentData, `${target[0]}/content/0/imageLink`.split('/'), '', state.editor.contents);
						yield put(toggleContentsTargetLoading({ target: target.join('/'), isLoading: false }));
				}
			}
			break;
		case 'map': 
			if (target[3] === 'address') {
				const result = yield call(generateMap, data);
				if (result === 'ZERO_RESULT') {
					Alert.error(msg.CHECK_MAP_ADDRESS);
					return;
				} else {
					const { image, link } = result;
					state.editor.contents = yield call(applyContentData, `${target[0]}/content/0/imagePath`.split('/'), image, state.editor.contents);
					state.editor.contents = yield call(applyContentData, `${target[0]}/content/0/imageLink`.split('/'), link, state.editor.contents);
					state.editor.contents = yield call(applyContentData, `${target[0]}/content/0/imageAlt`.split('/'), data, state.editor.contents);
				}
			}
			break;
	
		default:
			break;
	}

	if(target.includes('supportType')){
		state.editor.contents = yield call(applyContentData, target, data, state.editor.contents);
	}

	// 새로운 컨텐츠 적용 
	yield put(getContentsAsync.success(state.editor.contents));

	yield delay(50);
	// 수정된 상자 저장 요청

	if (needsToSave) {
		yield put(saveContentsAsync.request('normal'));
	} else {
		yield put(saveContentsLocal());
	}
}

function* saveContentsLocalSaga(action) {
	const target = action?.payload?.target?.split('/');
	
	const editor = yield select(state => state.editor);
	let contents = editor.contents;

	if (action?.payload?.data != null) {
		contents = yield combineContents(contents, target, action.payload);
	}

	const lastModifiedTime:number = Number(`${dayjs(new Date()).valueOf()}`);

	if (editor.ui.isContentsLoading) {
		return;
	}

	if (contents.length === 0) {
		return;
	}

	const contentsData: ContentsData = {
		lastModifiedTime: lastModifiedTime,
		data: contents
	}	

	const isContentsAbtest = editor.email.type === 2 && editor.email.subType === 4;
	let testGroup: editorState['testGroup'] = undefined;
	if (isContentsAbtest) {
		testGroup = yield select(state => state.editor.testGroup);
	}

	let saveKey = `stb_email_${editor.email.id}_contents`;
	if (testGroup) saveKey = saveKey + `_${testGroup}`;
	
	yield call(putContentsLocal, saveKey, contentsData);
	window.parent.postMessage({ msg: 'saveLocalCompleted', saveKey, contents: contentsData }, '*');
	console.log('%c💾saveContentsLocalSaga', 'color:black;background:yellow');
}

function* combineContents (current, target, source) {
	let result = current;
	const { data, videoId } = source;
	// TODO: 현재는 텍스트 상자만 동작 보장됨, 다른 상자는 테스트 해보고 점차적으로 적용
	const state = yield select(state => state);
	if (!target.includes('text')) return current;

	if (target.includes('content') || target[1] === 'column' || target[1] === 'type') {
		result = yield call(applyContentData, target, data, result);

		switch (true) {
			case target[1] === 'type':
				if (data.includes('shop')) {
					result = yield call(applyContentData, [target[0], 'column'], shopTypeSet[data], result);
				}
				break;
			case target[1] === 'content' && target[3] === 'imagePath':
				const targetItemIndex: any = result.findIndex((item: any) => { return item.id === Number(target[0]) });
				
				const oldImagePath = result[targetItemIndex].content.content[target[2]].imagePath;
        if (!oldImagePath.includes('dummy')) {
					// yield call(removeUploaded, oldImagePath, false);
				}
				break;
			// 텍스트 템플릿일 경우 중앙정령 X
			case target[1] === "content" && target[3] === "text":
				if (state.editor.email.templateId === TEXT_TEMPLATE) {
					state.editor.container = yield call(
						applyContainerData,
						["container", "margin"],
						"0px",
						state.editor.container
					);
					state.editor.container = yield call(
						applyContainerData,
						["container", "padding"],
						"0px",
						state.editor.container
					);
				}
				break;
			default:
				break;
		}
	}

	if (target.includes('style')) {
		result = yield call(applyStyleData, target, data, result);

		let lastTarget = target[4]; // ex) box
		if (target.length === 6) {
			lastTarget = target[5];
		}
		let middleTarget = target[3]; // ex) paddingLeft
		if (target.length === 6) {
			middleTarget = target[4];
		}
		const option = yield select((state) => state.editor.option);
		switch (true) {
			case middleTarget === 'button' && lastTarget === 'fontSize':
				result = yield call(applyStyleData, target, option.ctaPaddingBySize[data], result, 'padding');
				break;

			case middleTarget === 'button' && lastTarget === 'buttonType':	
				// border-radius만 변경한다				
				result = yield call(applyStyleData, target, option.buttonTypeOption[data].borderRadius, result, 'borderRadius');
				break;

			case middleTarget === 'button' && lastTarget === 'fullWidth':
				result = yield call(applyStyleData, target, data === 'wide' ? '100%' : 'auto', result, 'width');
				result = yield call(applyStyleData, target, 'center', result, 'textAlign');
				break;

			case middleTarget === 'button' && lastTarget === 'textAlign':
				result = yield call(applyStyleData, target, data, result, 'textAlign');
				result = yield call(applyStyleData, target, '', result, 'fullWidth');
				result = yield call(applyStyleData, target, 'auto', result, 'width');
				break;

			case middleTarget === 'box' && lastTarget === 'paddingLeft':
				result = yield call(applyStyleData, target, data, result, 'paddingRight');
				break;

			case middleTarget === 'box' && lastTarget === 'borderWidth':
				let t1 = [...target];
				t1.splice(1, 0, 'content');
				t1.pop();
				t1.push('borderColor');
				
				const currentBoxBorderColor = yield (getCurrentData(t1, result));
				
				if (currentBoxBorderColor.length === 0) {
					result = yield call(applyStyleData, target, '#000000', result, 'borderColor');
				}				
				break;

			case middleTarget === 'column' && lastTarget === 'paddingLeft':
				result = yield call(applyStyleData, target, data, result, 'paddingRight');
				break;

			case middleTarget === 'image' && lastTarget === 'fullWidth':
				result = yield call(applyStyleData, target, data === 'justify' ? '100%' : 'auto', result, 'width');
				result = yield call(applyStyleData, target, data === 'justify' ? '' : 'center', result, 'textAlign');
				break;
			case middleTarget === 'image' && lastTarget === 'textAlign':
				let t2 = [...target];
				t2.splice(1, 0, 'content');
				t2.pop();
				t2.push('width');
				
				const currentWidth = yield (getCurrentData(t2, result));

				if (currentWidth === 'auto' || currentWidth === '100%') {
					result = yield call(applyStyleData, target, 'auto', result, 'width');
				}
				result = yield call(applyStyleData, target, '', result, 'fullWidth');
				break;
			case middleTarget === 'image' && lastTarget === 'width':
				result = yield call(applyStyleData, target, data === 'auto' ? '100%' : data, result, 'width');
				break;

			default:
				break;
		}

		// edited 마킹
		switch(middleTarget) {			
			case 'partition':
				result = markEdited(target, result, 'partition');
				break;				
			case 'button':
				result = markEdited(target, result, `button${target[2]}`);
				break;
			case 'box':
				result = markEdited(target, result, 'box');
				break;

			default:
				break;
		}
	}

	// 상자별 옵션	
	const targetItemIndex: any = result.findIndex((item: any) => { return item.id === Number(target[0]) });
	const targetItem = result[targetItemIndex];

	if (targetItemIndex === -1) {
		return;
	}	
	switch (targetItem?.content?.category) {
		case 'base': 
			if (target[3] === 'imagePath') {
				result = yield call(applyContentData, `${target[0]}/content/${target[2]}/imageAlt`.split('/'), '', result);
			}
			break;
		case 'video':
			if (target[3] === 'imageLink') {
				const { imgUrl, errorMessage } = yield call(getYoutubeThumbnail, data, state.editor.emailId);
				const videoStartTime = urlToStartTime(data);

				if (imgUrl === undefined || errorMessage != null) {
					// Alert.error(msg.CHECK_VIDEO_URL);
					result = yield call(applyContentData, `${target[0]}/content/0/imageLink`.split('/'), '', result);
					return;
				}
				
				result = yield call(applyContentData, `${target[0]}/content/0/imagePath`.split('/'), imgUrl, result);
				result = yield call(applyContentData, `${target[0]}/content/0/imageAlt`.split('/'), '', result);
				result = yield call(applyContentData, `${target[0]}/content/0/videoId`.split('/'), videoId, result);
				const targetItemIdx: any = result.findIndex((item: any) => { return item.id === Number(target[0]) });
				const { videobox, embedvideo } = result[targetItemIdx].content.style[0];
				if (!(videobox && embedvideo)) {
					const { value: { style } } = components.find((item) => targetItem?.content?.category === item.value.category);
					const { videobox: videoboxStyle, embedvideo: embedvideoStyle } = style[0];
					result = yield call(applyStyleData, `${target[0]}/style/0/videobox`.split('/'), videoboxStyle, result);
					result = yield call(applyStyleData, `${target[0]}/style/0/embedvideo`.split('/'), embedvideoStyle, result);
				}
				if (!!videoStartTime) {
					result = yield call(applyContentData, `${target[0]}/content/0/videoStartTime`.split('/'), videoStartTime, result);
				}
			}
			break;
		case 'map': 
			if (target[3] === 'address') {
				const mapResult = yield call(generateMap, data);
				if (mapResult === 'ZERO_RESULT') {
					// Alert.error(msg.CHECK_MAP_ADDRESS);
					return;
				} else {
					const { image, link } = mapResult;
					result = yield call(applyContentData, `${target[0]}/content/0/imagePath`.split('/'), image, result);
					result = yield call(applyContentData, `${target[0]}/content/0/imageLink`.split('/'), link, result);
					result = yield call(applyContentData, `${target[0]}/content/0/imageAlt`.split('/'), data, result);
				}
			}
			break;
	
		default:
			break;
	}

	if(target.includes('supportType')){
		result = yield call(applyContentData, target, data, result);
	}
	return result;
}

function* footerText() {
  const state = yield select();
  const msg = yield select(state => state.editor.service.msg);

  const hasNoList = state.editor.email.listId === -1 || state.editor.email.listId === undefined || state.editor.email.isListDeleted;
  if (hasNoList) {
    Alert.error(msg.CHECK_SELECT_LISTS);
    return;
  }

	const defaultEmail = state.editor.listInfo.senderEmails.find(email=>email.isDefault)
	const convertedEmail = convertToOriginEmail(defaultEmail?.email);

	const footerTextHtml = ((listInfo: any) => {
		return `
			<span style="color: #747579; font-size: 12px;">${listInfo.companyName || '여기에 회사명 또는 이름을 입력하세요.'}</span><br>
			<span style="color: #747579; font-size: 12px;">${listInfo.email}</span><br>
			<span style="color: #747579; font-size: 12px;">${listInfo.companyAddress || '여기에 주소를 입력하세요.'} ${listInfo.companyContact || '여기에 전화번호를 입력하세요.'}</span><br>
			<a href="${listInfo.unsubscribe}" style="text-decoration:underline;color:#606060;font-size: 12px;">수신거부</a>&nbsp;<a href="${listInfo.unsubscribe}" style="text-decoration:underline;color:#606060;font-size: 12px;">Unsubscribe</a>`;
	})({
		...state.editor.listInfo,
		unsubscribe: '$%unsubscribe%$',
		email: convertedEmail || defaultEmail.email
	});

	return footerTextHtml;
}

function* footerUpdateSaga(action:any) {
	const { payload } = action;

	const footerTextHtml = yield call(footerText);
	
	const newAction = {
		payload: {
			target: `${payload}/content/0/text`,
			data: footerTextHtml
		}
	}

	yield delay(200);
	yield call(editContentSaga, newAction);			
}

function* switchContentSaga(action:any) {
	const state = yield select();	
	const { payload } = action;		

	let n:any = produce(state.editor.contents, (draft: any[]) => {
		const targetItemIndex: any = draft.findIndex((item: any) => { return item.id === payload });
		
		draft[targetItemIndex].content.column = draft[targetItemIndex].content.column.reverse();
		draft[targetItemIndex].content.content = draft[targetItemIndex].content.content.reverse();
		draft[targetItemIndex].content.style = draft[targetItemIndex].content.style.reverse();

		if (!Array.isArray(draft[targetItemIndex].content.content[0])) {
			draft[targetItemIndex].content.style[0]['box'] = draft[targetItemIndex].content.style[1]['box'];
			draft[targetItemIndex].content.style[0]['outer'] = draft[targetItemIndex].content.style[1]['outer'];
			draft[targetItemIndex].content.style[0]['column'] = draft[targetItemIndex].content.style[1]['column'];
		}	else {
			draft[targetItemIndex].content.style[0][0]['box'] = draft[targetItemIndex].content.style[1][0]['box'];
			draft[targetItemIndex].content.style[0][0]['outer'] = draft[targetItemIndex].content.style[1][0]['outer'];
			draft[targetItemIndex].content.style[0][0]['column'] = draft[targetItemIndex].content.style[1][0]['column'];
		}
	});
	
	yield put(getContentsAsync.success(n));
	yield put(saveContentsLocal());
}

function* commonStylePaddings() {
	const state = yield select();

	return Object.keys(state.editor.container.commonStyle.box)
	.filter((key: string) => key.includes('padding'))
	.reduce((obj: any, key: string) => {
		obj[key] = state.editor.container.commonStyle.box[key];
		return obj;
	}, {});
}

function* addContentSaga(action: any) {
	const state = yield select();
	const msg = yield select(state => state.editor.service.msg);
	const { payload: { seq, componentId } } = action;

	// 네이버 광고 상자 개수 제한 체크
	if (componentId === 'naverAd') {
		const hasNaverAd = state.editor.contents.some((item: any) => 
			item.content?.category === 'naver-ad'
		);
		
		if (hasNaverAd) {
			Alert.error('네이버 광고 상자는 한 개만 추가할 수 있습니다.');
			return;
		}
	}

	//mixpanel 이벤트 용
	window.parent.postMessage({ msg: 'contentAdded', componentId }, '*');
	
	const { value } = components.filter((item:any) => {
		return item.text === componentId
	})[0];
	
	let newContent = {
		id: state.editor.contents.length === 0 ? 0 : maxBy(state.editor.contents, 'id') + 1,
		seq: seq,
		content: JSON.parse(JSON.stringify(value))
	}

	const commonStyleBoxPaddings = yield call(commonStylePaddings);

	newContent.content.style.map((item: any) => {
		// TODO: shop 타입 분기
		// naver-ad는 box padding도 제외
		if (!COMMON_STYLE_EXCLUDE_COMP.includes(newContent.content.category)) {
			item['box'] = { ...item['box'], ...commonStyleBoxPaddings } // padding만 적용
		}
		item['outer'] = { ...item['outer'], ...state.editor.container.commonStyle.outer }
		item['button'] = { ...item['button'], ...state.editor.container.commonStyle.button }
		item['partition'] = { ...item['partition'], ...state.editor.container.commonStyle.partition }
		if (!COMMON_STYLE_EXCLUDE_COMP.includes(newContent.content.category)) {
			item['text'] = { ...item['text'], ...state.editor.container.commonStyle.text }
		}
	});

	yield delay(100);

	if (componentId === 'footer') {
    const email = yield select(state => state.editor.email);
    const hasNoList = email.listId === -1 || email.listId === undefined || email.isListDeleted;
		if (hasNoList) {
			Alert.error(msg.CHECK_SELECT_LISTS);
			return;
		}

		const hasDefaultSender = state.editor.listInfo.senderEmails?.some((element: any) => {
			return element.isDefault === true;
		})

    if (state.editor.listInfo.senderEmails === undefined || !hasDefaultSender) {
      Alert.error(`기본 발신자가 지정되지 않아 푸터를 추가할 수 없습니다.<br><a href='/lists/${state.editor.email.listId}/dashboard' target='_blank'>주소록</a>에서 기본 발신자 주소를 지정해 주세요.`);
      return;
    }

		// 푸터 데이터 확인
		const footerValue = yield call(footerText);
		newContent.content.content[0].text = footerValue;
	}



	if (componentId === 'donationA') {
		const { auth: { account: { from } } } = state;
		if (from !== 'DONUS') {
			Alert.error(msg.DONUS_ONLY);
			return;
		}
	}

	const nextContents:any = produce(state.editor.contents, (draft: any) => {
		draft.splice(seq, 0, newContent);
		draft.map((item:any, index:number) => {
			item.seq = index;
		})
	});

	yield put(getContentsAsync.success(nextContents));
	yield put(saveContentsLocal());

	yield delay(100);

	yield call(saveEmailAndWebContentsSaga);
}

function* moveContentSaga(action: any) {
	const state = yield select();
	const { payload } = action;

	const nextContents:any = produce(payload, (draft: any[]) => {
		draft.map((item: any, index: number) => {
			item.seq = index;
		});
	});

	yield put(getContentsAsync.success(nextContents));
	yield put(saveContentsLocal());
}

function* getHistorySaga(action) {
	console.log('%c🗒getHistorySaga', 'color: black;background: tan;');
	const state = yield select();
	const isContentsAbtest = state.editor.email.type === 2 && state.editor.email.subType === 4;
	let testGroup: editorState['testGroup'] = undefined;
	if (isContentsAbtest) {
		testGroup = yield select(state => state.editor.testGroup);
	}

	try {
		const { editor: {contents, container} } = yield select();	
		const history = yield call(requestContentsSnapshot, action.payload.emailId, action.payload.offset, testGroup);

		const historyParsed:HistoryItem[] = [];
		for (const key in history.items) {
			if (Object.prototype.hasOwnProperty.call(history.items, key)) {
				let element = history.items[key];
				element['id'] = Number(key);				
				historyParsed.push(element);
			}
		}

		historyParsed.reverse();

		const currentHistoryItem:HistoryItem = {
			id: -1,
			lastModifiedTime: new Date().getTime(),
			contents: contents,
			container: container
		}
		
		if (action.payload.offset === 0) {
			historyParsed.unshift(currentHistoryItem);
		}

		history.items = historyParsed;
		yield put(getHistoryAsync.success(history));
	} catch (e) {
		yield put(getHistoryAsync.failure(e));
		console.error(e);
	}
}

function* applyHistorySaga(action:any) {
	const { editor: { email: { id } } } = yield select();
	const { contents, container, id: snapshotId } = action.payload;	

	checkoutSnapshot(id, snapshotId);

	yield put(getContentsAsync.success(contents));
	yield put(getContainerAsync.success(container));

	yield put(saveContentsLocal());
	yield call(saveEmailAndWebContentsSaga);
	yield call(saveContainerSaga);
}

let appStartTime = Date.now();

function* historySaveSaga(action) {
	const now = Date.now();
	const elapsedTime = now - appStartTime;
	console.log('%c💾historySaveSaga', 'color: black;background:yellow');
	// 콘텐츠 수정으로 인한 저장 시 첫 10분은 저장 안함
  if(action?.type === 'emailContents/EDIT_CONTENT' && elapsedTime < HISTORY_SAVE_DURATION){
		return;
  }
	const { editor: { contents, email: { id, type, subType, templateId }, container } } = yield select();
	//최신 히스토리 목록 불러오기
	yield call(getHistorySaga, {payload: {emailId:id, offset:0}})
	const { editor: { history } } = yield select();

	const isNewEmail = id === -1;
	const isTextTemplate = templateId === TEXT_TEMPLATE;
	const isEmptyContent = contents.length === 0;
	const isHistoryLoaded = !!history?.items?.length;
	const hasHistory = history?.items?.length >= 2;
	const isSameAsLastSaved = hasHistory && JSON.stringify(history.items[1].contents) === JSON.stringify(contents);

	if (
		isNewEmail ||
		isTextTemplate ||
		isEmptyContent ||
		!isHistoryLoaded ||
		isSameAsLastSaved
	) {
		return;
	}	

	const isContentsAbtest = type === 2 && subType === 4;
	let testGroup: editorState['testGroup'] = undefined;
	if (isContentsAbtest) {
		testGroup = yield select(state => state.editor.testGroup);
	}


	const data: HistoryItem = {
		lastModifiedTime: dayjs(new Date()).valueOf(),
		contents: contents,
		container: container
	}

	try {
		yield call(postContentsSnapshot, id, data, testGroup);
	} catch (error) {
		console.log('save snapshot fail');
		console.error(error);
	}	
}

function* manageLocalStorage() {
	console.log('%c💾manageLocalStorage', 'color: black;background:pink');
	
	const { editor: { emailId } } = yield select();
	const currentStorageKey = `stb_email_${emailId}_contents`;

	const localStorageContents = Object.keys(localStorage).map((key: string) => { if (key.includes('stb_email_')) return {key:key, lastModifiedTime: JSON.parse(localStorage.getItem(key) || '')['lastModifiedTime']} }).sort((a:any, b:any) => b.lastModifiedTime - a.lastModifiedTime);

	if (Object.keys(localStorage).length < (LOCAL_STORAGE_SAVE_LIMIT + 1)) {
		return;
	}

	localStorageContents.map((item:any, index:number) => {
		if (item?.key !== currentStorageKey && index >= LOCAL_STORAGE_SAVE_LIMIT) {
			localStorage.removeItem(item?.key);
		}	
	});
}

function* removeLocalSave() {
	const { editor: { emailId } } = yield select();
	const currentStorageKey = `stb_email_${emailId}_contents`;
	localStorage.removeItem(currentStorageKey);
	window.parent.postMessage({ msg: 'removeLocalStorage', currentStorageKey }, '*');

}

function* saveContentsSaga(renderModeOrAction?: ActionType<typeof saveContentsAsync.request>['payload']) {
	console.log('%c💾saveContentsSaga', 'color: black;background:yellow', renderModeOrAction);
	
	let renderMode = typeof renderModeOrAction === 'string' ? renderModeOrAction : 'normal';
	let supportType;
	let testGroupFromAction: editorState['testGroup'];
	if (typeof renderModeOrAction === 'object') {
		renderMode = renderModeOrAction.renderingOption ?? 'normal';
		supportType = renderModeOrAction.isWebSupport ? 'WEB' : undefined;
		if (renderModeOrAction.testGroup) testGroupFromAction = renderModeOrAction.testGroup;
	}
	
	yield put(saveContentsLocal());
	yield call(manageLocalStorage);

	const { editor: { container, contents, email: { id }, ui: {isContentsLoading, contentsSaving}}, auth: {token, account} } = yield select();
	const isAccountInfoLoading = account.id === '';
	if (isAccountInfoLoading) return;

	if (isContentsLoading) {
		return;
	}

	yield put(toggleIsSaving(true));
	
	// TODO: retac.

	if (id === -1) {
		yield put(toggleIsSaving(false));
		return;
	}

	let email: Email;
	try {
		email = yield call(requestEmail, id);
	} catch (e) {
		console.error('requestEmail failed:', e);
		yield put(saveContentsAsync.failure(e));
		yield put(toggleIsSaving(false));
		window.parent.postMessage({ msg: 'saveFailed', supportType }, '*');
		return;
	}

	const isContentsAbtest = email.type === 2 && email.subType === 4;
	let testGroup: editorState['testGroup'] = undefined;
	if (isContentsAbtest) {
		testGroup = yield select(state => state.editor.testGroup);
	}


	if (contents.length === 0) {
		yield put(toggleIsSaving(false));
		yield call(removeLocalSave);
		window.parent.postMessage({ msg: 'saveCompleted', supportType, testGroup }, '*');
		return;
	}

	if (isContentsAbtest && testGroupFromAction && testGroupFromAction !== testGroup) {
		try {
			yield call(saveHtmlByServerData, email, { token, account }, { renderingOption: renderMode, supportType, testGroup: testGroupFromAction });
			yield put(saveContentsAsync.success());
			yield put(toggleIsSaving(false));
			yield call(removeLocalSave);
			window.parent.postMessage({ msg: 'saveCompleted', supportType, testGroup: testGroupFromAction }, '*');
		} catch (e) {
			console.error(e);
			yield put(saveContentsAsync.failure(e));
			yield put(toggleIsSaving(false));
			window.parent.postMessage({ msg: 'saveFailed', supportType, testGroup: testGroupFromAction }, '*');
			return;
		}
		return;
	}

	const postContentData: ContentsData = {
		lastModifiedTime: Number(`${dayjs(new Date()).valueOf()}`),
		data: contents
	}


	const htmlData: RequestHtml = {
		emailId: id,
		auth: {
			token: token,
			account: account
		},
		data: {
			contents: contents,
			container: container
		},
		isNoneUnsub: false,
		option: renderMode,
		previewText: email.plainText || '',
		supportType,
		templateId: email.templateId,
	}

	try {
		yield call(postContents, id, postContentData, testGroup);
		const htmlOutput = yield call(requestGenerateHtml, htmlData, { newHtmlRendering: account.options.newHtmlRendering });
		if (htmlOutput === 'html 생성에 문제가 있습니다.') {
			throw new Error(htmlOutput);
		}
		const options = { purpose: supportType };
		if (testGroup) options['type'] = testGroup;
		yield call(requestSaveHtml, id, htmlOutput, options);

		
		yield put(saveContentsAsync.success());
		yield call(removeLocalSave);
		yield put(toggleIsSaving(false));
	} catch (e) {
		yield put(saveContentsAsync.failure(e));		
		yield put(toggleIsSaving(false));
		console.error(e);
		window.parent.postMessage({ msg: 'saveFailed', supportType, testGroup }, '*');
		return;
	}
	window.parent.postMessage({ msg: 'saveCompleted', supportType, testGroup }, '*');
}

async function saveHtmlByServerData(email: Email, auth, options: { renderingOption: 'normal' | 'outlook' | 'publish'; supportType?: 'WEB'; testGroup?: 'A' | 'B' }) {
	const { id: emailId } = email;
	const { token, account } = auth;
	const { testGroup, supportType } = options;
	const { data: contents } = await requestContents(emailId, testGroup);
	const style = await requestContainer(emailId, testGroup);
	const htmlData: RequestHtml = {
		emailId,
		auth: {
			token,
			account,
		},
		data: {
			contents,
			container: style,
		},
		isNoneUnsub: false,
		option: options.renderingOption,
		previewText: email.plainText || '',
		supportType,
		templateId: email.templateId,
	};

	const htmlOutput = await requestGenerateHtml(htmlData, { newHtmlRendering: account.options.newHtmlRendering });
	const htmlOptions = { purpose: supportType };
	if (testGroup) htmlOptions['type'] = testGroup;
	await requestSaveHtml(emailId, htmlOutput, htmlOptions);
};

function* saveEmailAndWebContentsSaga(payload?: Parameters<typeof saveContentsSaga>[0]) {
	let otherContentsPayload: typeof payload;
	if (typeof payload !== 'string' && payload !== undefined) {
		otherContentsPayload = {
			...payload,
			isWebSupport: !payload?.isWebSupport,
		}
	} else {
		otherContentsPayload = {
			renderingOption: payload,
			isWebSupport: true,
		};
	}

	// 각각 독립적으로 실행하되, 에러가 발생해도 계속 진행
	try {
		yield call(saveContentsSaga, payload);
	} catch (e) {
		console.error('First saveContentsSaga failed:', e);
		// 에러를 무시하고 계속 진행
	}
	
	try {
		yield call(saveContentsSaga, otherContentsPayload);
	} catch (e) {
		console.error('Second saveContentsSaga failed:', e);
		// 에러를 무시하고 계속 진행
	}
}

function* requestSaveSaga(action: ActionType<typeof requestSave>) {
	console.log('editContentSaga', action);

	yield call(saveEmailAndWebContentsSaga, action.payload);
}

function* saveContainerSaga() {
	const { editor: { container, email: { id } } } = yield select();
	yield call(putContainer, id, container);	
}

function* dialogShowSaga() {
	window.parent.postMessage({ msg: 'dialogShow' }, '*');
}

function* dialogHideSaga() {
	window.parent.postMessage({ msg: 'dialogHide' }, '*');
}

// Saved Box Saga Functions
function* saveBoxSaga(action: any) {
	try {
		const { contentId, name } = action.payload;
		const state = yield select();
		const content = state.editor.contents?.find((item: any) => item.id === contentId);
		
		if (!content) {
			yield put(saveBoxAsync.failure(new Error('Content not found')));
			Alert.error('이런, 뭔가 문제가 있는 것 같습니다.');
			return;
		}

		const boxData = {
			name,
			preset: content.content
		};

		const savedBox = yield call(saveSavedBox, boxData);
		yield put(saveBoxAsync.success(savedBox));
		
		// 저장된 박스 목록 다시 로드
		yield put(loadSavedBoxesAsync.request());
		
		Alert.log(`상자를 저장했습니다.`);
	} catch (error: any) {
		yield put(saveBoxAsync.failure(error));
		Alert.error('이런, 뭔가 문제가 있는 것 같습니다.');
	}
}

function* loadSavedBoxesSaga(action?: any) {
	try {
		const { offset = 0, limit = 15, isLoadMore = false } = action?.payload || {};
		
		const response = yield call(loadSavedBoxes, offset, limit);
		
		// API 응답을 Redux state에 맞는 형식으로 변환
		const transformedData = {
			boxes: response.presets,
			meta: {
				total: response.total,
				offset: response.offset,
				limit: response.limit,
				hasMore: (response.offset + response.limit) < response.total
			},
			isLoadMore
		};
		
		yield put(loadSavedBoxesAsync.success(transformedData));
		
	} catch (error: any) {
		
		yield put(loadSavedBoxesAsync.failure(error));
		Alert.error('이런, 뭔가 문제가 있는 것 같습니다.');
	}
}

function* renameSavedBoxSaga(action: any) {
	try {
		const { id, name } = action.payload;
		yield call(updateSavedBox, id, name);
		
		yield put(loadSavedBoxesAsync.request());
		yield put(renameSavedBoxAsync.success(null));
		
		Alert.log(`상자를 수정했습니다.`);
	} catch (error: any) {
		
		yield put(renameSavedBoxAsync.failure(error));
		Alert.error('이런, 뭔가 문제가 있는 것 같습니다.');
	}
}

function* deleteSavedBoxSaga(action: any) {
	try {
		const boxId = action.payload;

		// API 호출
		yield call(deleteSavedBox, boxId);
		
		// 기존 limit을 유지하여 다시 로드 (삭제 후에도 같은 개수만큼 보이도록)
		const currentState: editorState = yield select((state: any) => state.editor);
		const currentLimit = Math.max(currentState.savedBoxes.length, 33);
		yield put(loadSavedBoxesAsync.request({ offset: 0, limit: currentLimit, isLoadMore: false }));
		yield put(deleteSavedBoxAsync.success(null)); // success 액션만 전달
		
		Alert.log('삭제했습니다.');
		
	} catch (error: any) {
		yield put(deleteSavedBoxAsync.failure(error));
		Alert.error('이런, 뭔가 문제가 있는 것 같습니다.');
	}
}

function* addSavedBoxSaga(action: any) {
	try {
		const { seq, boxId } = action.payload;
		const state = yield select();
		
		// API를 통해 상자 상세 정보 로드
		const boxDetail = yield call(loadSavedBoxDetail, boxId);

		// 새로운 컨텐츠 아이템 생성
		let newContent = {
			id: state.editor.contents.length === 0 ? 0 : maxBy(state.editor.contents, 'id') + 1,
			seq: seq,
			content: JSON.parse(JSON.stringify(boxDetail)) // API에서 로드한 데이터 사용
		};

		yield delay(100);

		const nextContents: any = produce(state.editor.contents, (draft: any) => {
			draft.splice(seq, 0, newContent);
			draft.map((item: any, index: number) => {
				item.seq = index;
			})
		});

		yield put(getContentsAsync.success(nextContents));
		yield put(saveContentsLocal());

		yield delay(100);

		yield call(saveEmailAndWebContentsSaga);
		
		// 성공 액션 디스패치
		yield put(addSavedBoxAsync.success(newContent));
		
	} catch (error: any) {
		Alert.error('이런, 뭔가 문제가 있는 것 같습니다.');
		yield put(addSavedBoxAsync.failure(error));
	}
}

function* switchTestGroupSaga(action:any) {
	window.parent.postMessage({msg: 'onSpinner'}, '*');

	const emailId = action.payload;
	const from: editorState['testGroup'] = yield select((state: RootState) => state.editor.testGroup);
	const to: editorState['testGroup'] = from === 'A' ? 'B' : 'A';
	window.parent.postMessage({msg: 'changeTestGroup', value: to}, '*');

	yield call(saveEmailAndWebContentsSaga);
	yield call(saveContentsLocalSaga);
	yield call(historySaveSaga);
	yield put(selectContent(-1));

	yield put(setTestGroup(to));
	
	yield call(getContentsSaga, { payload: emailId });
	yield call(getContainerSaga, { payload: emailId });
	yield call(getFilesizeSaga, { payload: emailId });

	window.parent.postMessage({msg: 'offSpinner'}, '*');
}

function* syncTestGroupContentsSaga(action:any) {
	window.parent.postMessage({msg: 'onSpinner'}, '*');

	const emailId = action.payload;
	const to: editorState['testGroup'] = yield select((state: RootState) => state.editor.testGroup) ?? 'A';
	const from: editorState['testGroup'] = to === 'A' ? 'B' : 'A';

	yield call(historySaveSaga);

	try {
		yield call(syncTestGroupContents, emailId, from, to);

		yield call(getContentsSaga, { payload: emailId });
		yield call(getContainerSaga, { payload: emailId });
		yield call(getFilesizeSaga, { payload: emailId });

		window.parent.postMessage({msg: 'offSpinner'}, '*');
	} catch (error) {
		console.error(error);
	}
}

export function* editorSaga() {
	yield takeEvery(SET_TOKEN, setTokenSaga);
	yield takeEvery(GET_CONTENTS, getContentsSaga);
	yield takeEvery(ADD_CONTENT, addContentSaga);
	yield takeEvery(REMOVE_CONTENT, removeContentSaga);
	yield takeEvery(COPY_CONTENT, copyContentSaga);
	yield takeEvery(SWITCH_CONTENT, switchContentSaga);

	yield takeEvery(SWITCH_TEST_GROUP, switchTestGroupSaga);
	yield takeEvery(SYNC_TEST_GROUP_CONTENTS, syncTestGroupContentsSaga);

	yield takeEvery(GET_EMAIL, getEmailSaga);
	yield takeEvery(GET_CONTAINER, getContainerSaga);
	yield takeEvery(EDIT_CONTAINER, editContainerSaga);
	yield takeEvery(GET_FILESIZE, getFilesizeSaga);
	yield takeEvery(APPLY_FILESIZE, applyFilesizeSaga);
	
	yield takeEvery(EDIT_CONTENT, editContentSaga);
	yield takeEvery(MOVE_CONTENT, moveContentSaga);

	yield throttle(HISTORY_SAVE_DURATION, EDIT_CONTENT, historySaveSaga);
	yield throttle(10 * SEC, HISTORY_SAVE, historySaveSaga);
	yield throttle(CONTENTS_SAVE_DURATION, EDIT_CONTENT, saveEmailAndWebContentsSaga);
	yield takeLatest(SAVE_CONTENTS_LOCAL, saveContentsLocalSaga);
	yield takeEvery(SAVE_CONTENTS, saveEmailAndWebContentsSaga);
	yield takeEvery(REQUEST_SAVE, requestSaveSaga);

	yield takeEvery(GET_SYSTEMFIELDS, getSystemFieldsSaga);
	yield takeEvery(GET_LISTVARS, getListVarsSaga);
	yield takeEvery(GET_LISTINFO, getListInfoSaga);

	yield takeEvery(GET_HISTORY, getHistorySaga);
	yield takeEvery(HISTORY_APPLY, applyHistorySaga);
	yield takeEvery(FOOTER_UPDATE, footerUpdateSaga);

	yield takeEvery(DIALOG_SHOW, dialogShowSaga);
	yield takeEvery(DIALOG_HIDE, dialogHideSaga);

	// Saved Box Sagas
	yield takeEvery(SAVE_BOX, saveBoxSaga);
	yield takeEvery(LOAD_SAVED_BOXES, loadSavedBoxesSaga);
	yield takeEvery(RENAME_SAVED_BOX, renameSavedBoxSaga);
	yield takeEvery(DELETE_SAVED_BOX, deleteSavedBoxSaga);
	yield takeEvery(ADD_SAVED_BOX, addSavedBoxSaga);
}